import script from "./links-pill.vue?vue&type=script&setup=true&lang=ts"
export * from "./links-pill.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__